import React from 'react';
import { useCart } from './CartContext';
import './CartSummary.css';

const CartSummary = ({selectedProducts, setSelectedProducts, onCompleteSelection}) => {
    const { cartItems, setCartItems } = useCart(); 

    const handleRetry = () => {
        setCartItems((prevItems) => prevItems.filter(item => !selectedProducts.some(product => product.id === item.id)));
        setSelectedProducts([]);
    };

    return (
        <div className='count'>
            <div className='selected-products'>
                <span className='retry-button' onClick={handleRetry}>
                    <img src="/minus.png" alt="Minus" className='retry-image' />
                    상품 다시담기
                </span>
                <div className='total-items'>
                    <span className='total-items-label'>선택한 총 상품</span>
                    <span className='total-items-count'>{selectedProducts.length}종</span>
                </div>
            </div>
            <button className='complete-selection-button' onClick={onCompleteSelection}>상품 선택 완료</button>
            <p className='note'>상품추가 후 수량을 선택할 수 있어요</p>
        </div>
    )
}

export default CartSummary;
